<template>
  <b-modal
    id="newVehicleModal"
    size="md"
    content-class="sub-menu-bg-blue-transparent nv-modal"
    title="Add New Vehicle"
    hide-footer
    no-fade
    header-close-variant="light"
  >
    <div class="uv-body">

      <!-- Vehicle Name -->
      <div class="uv-field">
        <label class="uv-label">Vehicle Name</label>
        <b-form-input
          v-model="form.vehicle_name"
          placeholder="Enter vehicle name..."
          autocomplete="off"
        />
      </div>

      <!-- Region — single-select chips -->
      <div class="uv-field">
        <label class="uv-label">Region</label>
        <div class="uv-region-grid">
          <button
            v-for="r in regionOptions"
            :key="r.extent_id"
            type="button"
            class="uv-region-chip"
            :class="{ selected: form.region == r }"
            @click="form.region = r"
          >
            {{ r.region_name }}
          </button>
        </div>
      </div>

      <!-- Actions -->
      <div class="uv-actions">
        <b-button
          variant="primary"
          @click="submit()"
          :disabled="!isValid"
        >
          Add Vehicle
        </b-button>
      </div>

    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
import dpr_new_vehicle from '!!raw-loader!../../../emails/dpr_new_vehicle.html'
export default {
  name: 'MMP_DPR_NewVehicle',
  props: ['user'],
  data() {
    return {
      form: {
        vehicle_name: '',
        region: null
      },
      regionOptions: [],
      email_recipients: []
    }
  },
  computed: {
    isValid() {
      return this.form.vehicle_name.trim().length > 0 && !!this.form.region
    }
  },
  mounted() {
    this.getRegions()
    this.getEmailRecipients();
  },
  methods: {
    submit() {
      if (!this.isValid) return
      if (sessionStorage.token) {
        axios.post(process.env.API_LOCATION + '/api/dpr/addVehicle', {
          vehicle_name: this.form.vehicle_name.trim(),
          region: this.form.region.extent_id,
          user: this.user.id
        }, {
          headers: { 'x-auth-token': sessionStorage.token }
        }).then(response => {
          const content = response.data
          if (content.errors) {
            this.$bvToast.toast(content.errors, {
              title: 'Add Vehicle Error',
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            })
          } else {
            this.$bvToast.toast('Vehicle added successfully.', {
              title: 'Vehicle Added',
              variant: 'success',
              autoHideDelay: 5000,
              toaster: 'b-toaster-top-right'
            })
            this.$emit('refresh')
            this.sendEmail();
            this.$bvModal.hide('newVehicleModal')
          }
        }).catch(error => console.log(error))
      } else {
        console.log('No User Token')
      }
    },
    getRegions() {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/dpr/getAcquisitionRegions', {
          headers: { 'x-auth-token': sessionStorage.token }
        }).then(response => {
          const content = response.data
          if (content.errors) {
            this.$bvToast.toast(content.errors, {
              title: 'Add Vehicle Error',
              variant: 'danger',
              toaster: 'b-toaster-top-right'
            })
          } else {
            this.regionOptions = content.rows
          }
        }).catch(error => console.log(error))
      } else {
        console.log('No User Token')
      }
    },
    getEmailRecipients() {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/email/getRecipients', {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            module: 'dpr_new_vehicle'
          }
        })
        .then(response => {
          this.email_recipients = response.data[0].recipients;
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    },
    sendEmail() {
      const fromEmail = 'mmp-info@dmp-maps.com'
      const emailSubject = 'Acquisition Vehicle Added'
      let year = new Date().getFullYear()

      let now = new Date().toLocaleDateString(navigator.language, {month: '2-digit', day: '2-digit', year: 'numeric'})

      const emailBody = dpr_new_vehicle
              .replace('{{ vehicleName }}', this.form.vehicle_name)
              .replace('{{ region }}', this.form.region.region_name)
              .replace('{{ created_date }}', now)
              .replace('{{ newScannerSerial }}', this.newSerialNumber)
              .replace('{{ userName }}', this.user.name)
              .replace('{{ userEmail }}', this.user.email)
              .replace('{{ year }}', year)

      if (sessionStorage.token) {
          axios.post(
                process.env.API_LOCATION + '/api/email/sendemail',
                {
                    fromEmail: fromEmail,
                    toEmail: this.email_recipients,
                    emailSubject: emailSubject,
                    emailBody: emailBody
                },
                {
                    headers: {
                        'x-auth-token': sessionStorage.token
                    }
                }
            ).then(response => {
                const content = response.data
                if (content.errors) {
                    console.log('sendEmail API Call Error')
                } else {
                    if (content.some(obj => obj.status !== 'bounced' || obj.status !== 'rejected')) {
                      this.$bvToast.toast('Email sent.', {
                          autoHideDelay: 5000,
                          variant: 'success',
                          solid: true,
                          title: 'Email Sent',
                          toaster: 'b-toaster-top-right'
                      })
                    }

                    this.resetForm()
                }
            })
            .catch(function (error) {
                console.log(error)
                self.feedback = error.response.data.errors[0].msg
                self.showFeedback()
            })
      } else {
        console.log('No User Token')
      }
    },
    resetForm() {
      this.form.vehicle_name = ''
      this.form.region = null
    }
  }
}
</script>

<style scoped>
.uv-body {
  padding: 4px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Form fields */
.uv-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.uv-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(6, 60, 109, 0.7);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  margin: 0;
}

/* Region single-select chips */
.uv-region-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.uv-region-chip {
  padding: 5px 16px;
  border-radius: 20px;
  border: 1px solid rgba(6, 60, 109, 0.2);
  background: rgba(6, 60, 109, 0.04);
  color: rgba(6, 60, 109, 0.6);
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}
.uv-region-chip:hover {
  background: rgba(6, 60, 109, 0.08);
  color: #063c6d;
}
.uv-region-chip.selected {
  background: rgba(6, 60, 109, 0.1);
  border-color: #063c6d;
  color: #063c6d;
  font-weight: 600;
}

/* Actions */
.uv-actions {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}
</style>

<style>
.nv-modal .form-control {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.nv-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
</style>
